import { call, put } from 'redux-saga/effects';
export function sagaApiGenWithPromise(apiAction, resultSucceededAction, resultFailedAction, hasPromise = true) {
    return function* (action) {
        var _a, _b;
        try {
            const result = yield call(apiAction, action.payload);
            if (hasPromise) {
                if ((_a = action === null || action === void 0 ? void 0 : action.meta) === null || _a === void 0 ? void 0 : _a.resolve) {
                    yield call(action.meta.resolve, result);
                }
                else {
                    console.warn("action.meta.resolve was not set in action, consider using sagaApiGen if you don't need promisify your dispatches.");
                }
            }
            yield put(resultSucceededAction(result, { request: action.payload }));
        }
        catch (exception) {
            console.warn(exception);
            if (hasPromise) {
                if ((_b = action === null || action === void 0 ? void 0 : action.meta) === null || _b === void 0 ? void 0 : _b.reject) {
                    // Something went wrong. We reject the promise.
                    yield call(action.meta.reject, exception);
                }
                else {
                    console.warn("action.meta.reject was not set in action, consider using sagaApiGen if you don't need promisify your dispatches.");
                }
            }
            yield put(resultFailedAction(exception, { request: action.payload }));
        }
    };
}
export function sagaApiGen(apiAction, resultSucceededAction, resultFailedAction) {
    return sagaApiGenWithPromise(apiAction, resultSucceededAction, resultFailedAction, false);
}
export function bindActionToPromise(dispatch, actionCreator) {
    return (payload) => {
        return new Promise((resolve, reject) => dispatch(actionCreator(payload, resolve, reject)));
    };
}
